<div
  class="project-config-node-container"
  [class.selected]="selected()"
  [class.archived]="isArchived"
  (mouseenter)="hovering.emit(true)"
  (mouseleave)="hovering.emit(false)"
>
  <div class="project-config-node-inner">
    <div class="summary-item-content-wrapper">
      <app-svg-icon
        class="drag-handle"
        icon="drag-drop-vertical"
        color="var(--color-grey-900)"
        [strokeWidth]="3"
      ></app-svg-icon>
      @if (isEditing) {
        <div class="edit-content-wrapper">
          <ng-container *ngTemplateOutlet="editTemplate"></ng-container>
          <div class="edit-actions">
            <app-svg-icon
              icon="tick"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-green-500)"
              class="gpd-button-icon"
              (click)="$event.stopPropagation(); save()"
            ></app-svg-icon>
            <app-svg-icon
              icon="cancel"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-red-500)"
              class="gpd-button-icon"
              (click)="$event.stopPropagation(); cancel()"
            ></app-svg-icon>
          </div>
        </div>
      } @else {
        @if (displayTemplate) {
          <div class="template-content-wrapper">
            <ng-container *ngTemplateOutlet="displayTemplate"></ng-container>
          </div>
        } @else {
          <!-- Default display template -->
          <div class="summary-item-content-wrapper">
            <div class="summary-item-content">
              <span class="item-number">{{ itemNumber }}.</span>
              <ng-content></ng-content>
            </div>
          </div>
        }
        <div class="item-actions">
          @if (allowEdit) {
            <app-svg-icon
              icon="edit"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-grey-500)"
              class="gpd-button-icon"
              (click)="$event.stopPropagation(); startEdit()"
            ></app-svg-icon>
          }
          @if (allowArchive) {
            <app-svg-icon
              icon="archive"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-grey-500)"
              class="gpd-button-icon"
              i18n-title="@@archive"
              title="Archivieren"
              (click)="$event.stopPropagation(); onArchive.emit()"
            ></app-svg-icon>
          }
          @if (allowDelete) {
            <app-svg-icon
              icon="delete"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-red-500)"
              class="gpd-button-icon"
              (click)="$event.stopPropagation(); onDelete.emit()"
            ></app-svg-icon>
          }
          @if (isArchived) {
            <app-svg-icon
              icon="reactivate"
              [size]="16"
              [strokeWidth]="1.5"
              color="var(--color-grey-500)"
              class="gpd-button-icon"
              i18n-title="@@reactivate"
              title="Reaktivieren"
              (click)="$event.stopPropagation(); onReactivate.emit()"
            ></app-svg-icon>
          }
        </div>
      }
    </div>
  </div>
</div>
